/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "memorialAPI",
            "endpoint": "https://ymt7txiz75.execute-api.eu-west-1.amazonaws.com/trad",
            "region": "eu-west-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-1:69d1875b-da4a-450d-8650-486b704e8973",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_eZY7eWZ9e",
    "aws_user_pools_web_client_id": "43hlfp3083qdjkeii4jk44up5b",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "eu-west-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "condolencesTable-trad",
            "region": "eu-west-1"
        },
        {
            "tableName": "memoriesTable-trad",
            "region": "eu-west-1"
        }
    ],
    "aws_user_files_s3_bucket": "digital-memorial-mediae09d9-trad",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
